import { useEffect } from 'react';
import { faviconUrl, useBrandingStatus } from './useBranding';

/** Ставит/обновляет <link rel="icon"> в head в зависимости от статуса брендинга.
 * Если фавикон не задан — удаляет свою ссылку (браузер покажет дефолтную). */
export function FaviconManager() {
  const { data } = useBrandingStatus();
  const url = faviconUrl(data);
  useEffect(() => {
    const ID = 'branding-favicon';
    const existing = document.getElementById(ID) as HTMLLinkElement | null;
    if (!url) {
      existing?.remove();
      return;
    }
    const link = existing ?? document.createElement('link');
    link.id = ID;
    link.rel = 'icon';
    link.href = url;
    if (data?.favicon?.mime) link.type = data.favicon.mime;
    if (!existing) document.head.appendChild(link);
  }, [url, data?.favicon?.mime]);
  return null;
}
